export default {
  mainContactTitle: {
    id: 'profile_page_contact_details_tab_main_contact_block_title',
    defaultMessage: 'Main contact',
  },
  mainContactDescription: {
    id: 'profile_page_contact_details_tab_main_contact_block_description',
    defaultMessage:
      'As the main contact, you’ll receive all email communications.',
  },
  mainContactInfo: {
    id: 'profile_page_contact_details_tab_main_contact_block_info',
    defaultMessage:
      'Need to change this email? Email your Seller Support Manager to make the change.',
  },
  additionalContactsTitle: {
    id: 'profile_page_contact_details_tab_additional_contact_block_title',
    defaultMessage: 'Additional contacts',
  },
  communicationLanguageTitle: {
    id: 'profile_page_contact_details_tab_language_block_title',
    defaultMessage: 'Language',
  },
}
